import React from 'react'
import Breadcrumbs from '../Breadcrumb'
import PropTypes from 'prop-types';

export default function PageWrapper(props) {

  return (
    // px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto mb-16
    <div className={props.className}>
      {(props.showBreadCrumbs !== false) && <div className='px-4 bg-white mb-4'><Breadcrumbs /></div>}
      <div className='min-h-screen bg-white rounded p-4  '>
        <div className="flex justify-between  items-center mb-2 ">
          <div className='text-xl font-semibold text-gray-800 capitalize'>{props.title}</div>
          <div>{props.actions}</div>
        </div>
        <div className='border-b border-gray-100 pb-2'>
          <p className='text-sm'>{props.description}</p>
        </div>
        <div className='pt-2 h-full '>
          {props.children}
        </div>
      </div>

    </div>

  )
}

PageWrapper.propTypes = {
  className: PropTypes.string,
  showBreadCrumbs: PropTypes.bool,
  title: PropTypes.node,
  description: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
};
